const payloadKey = (schedule) => (
  schedule?.id === undefined || schedule?.id === null
    ? null
    : String(schedule.id)
);

const comparablePayload = (schedule) => ({
  ...schedule,
  ...(payloadKey(schedule) !== null ? { id: payloadKey(schedule) } : {}),
});

/**
 * Return only new or modified schedules.
 *
 * The API already supports partial bulk updates: schedules omitted from the
 * request are left untouched. Keeping the comparison here makes the save
 * request proportional to the user's edit instead of to the whole program.
 */
export const selectChangedSchedules = (current = [], original = []) => {
  const originalsById = new Map(
    original
      .map(schedule => [payloadKey(schedule), schedule])
      .filter(([key]) => key !== null),
  );

  return current.filter((schedule) => {
    const key = payloadKey(schedule);
    if (key === null) return true;

    const previous = originalsById.get(key);
    return !previous ||
      JSON.stringify(comparablePayload(schedule)) !== JSON.stringify(comparablePayload(previous));
  });
};
